import { GroupChannel, Member } from '@sendbird/chat/groupChannel';
import { IconButton } from '@mui/material';
import React from 'react';
import { ChatVIPHeader, CoachAvatar, CoachDescription, CoachHeaderInfo, CoachHeaderText, CoachName } from '../chatStyled';
import { SVGCloseIcon } from '../icons';
import { SendbirdUser } from '../chat';

export interface ChatHeaderProps {
    user: SendbirdUser | undefined;
    channel: GroupChannel | null;
    coach?: Member | null;
    onClose?: () => void;
    isVipPage?: boolean;
    setView?: (view: 'init' | 'chat') => void; // Only needed for VIP Coaching page to switch from SubscriberPage to Chat view
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ user, channel, coach, setView, onClose, isVipPage }) => {
    
    const isSystemUser = (userId: string) =>
        userId === 'autoresponder' || 
        userId === 'admin' ||
        userId.startsWith('vip_coach') ||
        userId.startsWith('vip_support_');

    const isViewingAsCoachOrSupport =
        user?.user_role === 'coach' || user?.user_role === 'support' || window.pgUser?.is_coach;

    let memberFromChannel: Member | undefined;
    if (isViewingAsCoachOrSupport) {
        // Coach or support is viewing — find the subscriber member (not coach, not system user, not self)
        memberFromChannel = channel?.members.find(
            member => member.userId !== user?.user_id
                && !isSystemUser(member.userId)
        );
    } else {
        // Subscriber is viewing — find the coach member by userId prefix
        memberFromChannel = channel?.members.find(
            member => !isSystemUser(member.userId) && member.userId !== user?.user_id
        );
    }

    let userName: string;
    if (isViewingAsCoachOrSupport) {
        userName = memberFromChannel?.nickname || '';
    } else {
        // Fall back to the coach prop, then channel-found coach, then 'Performance Golf'
        userName = coach?.nickname || memberFromChannel?.nickname || 'Performance Golf';
    }

    const defaultAvatar = 'https://www.performancegolf.com/wp-content/uploads/2023/12/autoresponder.png';
    let avatarSrc: string;
    if (isViewingAsCoachOrSupport) {
        avatarSrc = memberFromChannel?.plainProfileUrl || defaultAvatar;
    } else {
        avatarSrc = coach?.plainProfileUrl || memberFromChannel?.plainProfileUrl || defaultAvatar;
    }

    const handleClose = () => {
        setView?.('init');
        onClose?.();
    };

    return (
        <ChatVIPHeader $isVipPage={isVipPage}>
            <CoachHeaderInfo>
                <CoachAvatar
                    src={avatarSrc}
                    alt={userName}
                />
                <CoachHeaderText>
                    <CoachName>{userName}</CoachName>
                </CoachHeaderText>
            </CoachHeaderInfo>
            <IconButton onClick={handleClose} size="small" aria-label="Close chat">
                {SVGCloseIcon}
            </IconButton>
        </ChatVIPHeader>
    );
}

export default ChatHeader;